import React, { useRef, useEffect } from 'react';
import Slider from "react-slick";
import slide1 from '../assets/banner_1.png';
import slide2 from '../assets/banner_2.png';


export default function SimpleSlider() {
  const sliderRef = useRef(null);

  useEffect(() => {
    const slider = sliderRef.current;

    const preventTouchEvents = (e) => {
      e.stopPropagation(); // Prevent the event from reaching the parent
    };

    if (slider) {
      // Attach event listeners to prevent touch events from propagating to parent
      slider.addEventListener('touchstart', preventTouchEvents);
      slider.addEventListener('touchmove', preventTouchEvents);
      slider.addEventListener('touchend', preventTouchEvents);
    }

    return () => {
      if (slider) {
        // Clean up the event listeners when the component is unmounted
        slider.removeEventListener('touchstart', preventTouchEvents);
        slider.removeEventListener('touchmove', preventTouchEvents);
        slider.removeEventListener('touchend', preventTouchEvents);
      }
    };
  }, []);

  const settings = {
    dots: false,
    infinite: true,
    speed: 1500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
    arrows: false,
  };

  return (
    <div className='WelcomeSlider' ref={sliderRef}>
      <img src={slide1} alt="Slide 1" />
    </div>
  );
}
